import { useEffect, useRef, useState } from "react";
//import CardFilter from "../CardFilter";
import ReportsComparaSmall from "./ReportsComparaSmall";
import { getMonthNames, getYearsUntilNow } from "helper/tools";
import { es } from "date-fns/locale";

function VentasDashboard() {
  const monthSelected = useRef();
  const monthSelectRef = useRef();

  const yearSelectRef = useRef();

  const reporteSmallRef = useRef();

  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);

  const [yearSelected, setYearSelected] = useState(null);

  useEffect(() => {
    const wideMonthNames = getMonthNames(es).map((month) => ({
      name: month,
      isSelected: false,
    }));
    setMonths(wideMonthNames);

    const yearNames = getYearsUntilNow(es).map((year) => ({
      name: year,
      isSelected: false,
    }));
    setYears(yearNames);

    //fetchData();
  }, []);

  useEffect(() => {
    console.log("---->>> " + months);
    //preselect month
    const date = new Date();

    const monthIndex = date.getMonth();
    monthSelectRef.current.value = monthIndex;

    yearSelectRef.current = date.getFullYear();
    setYearSelected(date.getFullYear());
    //fetchData(monthIndex);
    reporteSmallRef.current.changeSelectedMonth(
      monthIndex,
      yearSelectRef.current,
    );
  }, [months]);

  return (
    <div className="card">
      {/*<CardFilter filterChange={handleFilterChange} />*/}
      <div className="card-body">
        <div className="row">
          <h5 className="card-title" style={{ width: "55px" }}>
            Mes
          </h5>
          <div
            className=""
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: "10px",
              width: "310px",
            }}
          >
            <select
              ref={monthSelectRef}
              className="form-select"
              aria-label="Default select example"
              onChange={(item) => {
                const monthIndex = parseInt(item.currentTarget.value);
                monthSelected.current = monthIndex;
                //TODO  fetchData(monthIndex);
                monthSelectRef.current.value = monthIndex;
                //fetchData(monthIndex);
                reporteSmallRef.current.changeSelectedMonth(
                  monthSelectRef.current.value,
                  yearSelectRef.current,
                );
              }}
            >
              {months.map((item, index) => {
                return (
                  <option key={index} selected={item.isSelected} value={index}>
                    {item.name}
                  </option>
                );
              })}
            </select>

            <select
              ref={yearSelectRef}
              className="form-select"
              aria-label="Default select example"
              value={yearSelected}
              onChange={(item) => {
                const year = parseInt(item.currentTarget.value);
                setYearSelected(item.currentTarget.value);
                //TODO  fetchData(monthIndex);
                yearSelectRef.current = year;
                //fetchData(monthIndex);
                reporteSmallRef.current.changeSelectedMonth(
                  monthSelectRef.current.value,
                  yearSelectRef.current,
                );
              }}
            >
              {years.map((item, index) => {
                return (
                  <option
                    key={index}
                    selected={item.isSelected}
                    value={item.name}
                  >
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="row  gx-5">
          <div
            className="col card1 recent-sales overflow-auto"
            style={{
              backgroundColor: "transparent",
              borderRadius: "0px",
              marginBottom: "30px",
            }}
          >
            <ReportsComparaSmall ref={reporteSmallRef} />
          </div>
        </div>
        <div className="row  gx-5">
          <div
            className="col card1 recent-sales overflow-auto"
            style={{
              backgroundColor: "transparent",
              borderRadius: "0px",
              marginBottom: "30px",
            }}
          >
            {/*  <ReportCharts /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default VentasDashboard;
